import React from "react";

const NotConnectedIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        id="wrng"
        d="M16.282,16.282a8,8,0,1,0-11.314,0A8,8,0,0,0,16.282,16.282ZM9.73,6.758a.98.98,0,0,1,1.874.49c-.017.321-.034.625-.051.946-.068,1.182-.135,2.364-.186,3.529a.727.727,0,0,1-1.452-.034c-.017-.236-.017-.473-.034-.709-.051-.76-.084-1.52-.135-2.3-.034-.49-.051-.979-.084-1.469A.887.887,0,0,1,9.73,6.758Zm.895,6.349a1.006,1.006,0,0,1,1,.979.979.979,0,0,1-1.959.017A.97.97,0,0,1,10.625,13.107Z"
        transform="translate(-2.625 -2.625)"
        fill={fill ? fill : "#c7c7c7"}
      />
    </svg>
  );
};

export default NotConnectedIcon;
